// Environment-based API configuration
const config = {
  development: {
    API_BASE_URL: 'http://localhost:5010',
    FRONTEND_URL: 'http://localhost:3010',
    IS_PRODUCTION: false
  },
  production: {
    // Use dynamic origin to avoid CORS issues between www and non-www
    API_BASE_URL: '',  // Empty = use relative URLs (same origin)
    FRONTEND_URL: '',
    IS_PRODUCTION: true
  }
};

// Determine environment
const getEnvironment = () => {
  // Check if we're in production (deployed environment)
  if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    return 'production';
  }
  return 'development';
};

const currentEnvironment = getEnvironment();

// For production, dynamically set URLs based on current origin to avoid CORS issues
const getProductionConfig = () => {
  const origin = window.location.origin;
  return {
    API_BASE_URL: origin,
    FRONTEND_URL: origin,
    IS_PRODUCTION: true
  };
};

const currentConfig = currentEnvironment === 'production' 
  ? getProductionConfig() 
  : config[currentEnvironment];

// API URL helper function
export const createApiUrl = (endpoint) => {
  // Remove leading slash from endpoint to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;

  // Start from config base
  let baseUrl = currentConfig.API_BASE_URL;

  // If baseUrl is not set (e.g., production config uses relative), but we're clearly in dev (port 3000),
  // target the same host on port 5005 so LAN access works (192.168.x.x:3000 -> 192.168.x.x:5005)
  if (!baseUrl) {
    const port = window.location.port;
    const host = window.location.hostname;
    const protocol = window.location.protocol || 'http:';
    if (port === '3010') {
      baseUrl = `${protocol}//${host}:5010`;
    }
  }

  if (baseUrl) {
    return `${baseUrl}/${cleanEndpoint}`;
  }
  // Fallback to relative URL
  return `/${cleanEndpoint}`;
};

// Helper function for image URLs - handles both absolute and relative paths
// Normalizes same-domain URLs to current origin to avoid CORS issues
export const createImageUrl = (imagePath) => {
  if (!imagePath) return '';
  
  // If already absolute URL
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    // Check if URL is from our own domain
    try {
      const url = new URL(imagePath);
      const currentHost = window.location.hostname.replace('www.', '');
      const imageHost = url.hostname.replace('www.', '');
      if (currentHost === imageHost) {
        return `${window.location.origin}${url.pathname}`;
      }
    } catch (e) {
      return imagePath;
    }
    return imagePath;
  }
  
  // Remove leading slash and use createApiUrl
  const cleanPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;
  return createApiUrl(cleanPath);
};

// Export configuration
export const {
  API_BASE_URL,
  FRONTEND_URL,
  IS_PRODUCTION
} = currentConfig;

const configExport = {
  ...currentConfig,
  createApiUrl,
  currentEnvironment
};

export default configExport; 